import Loose from './loose';
import Strict from './strict';
export { Loose, Strict };


//////////////////
// WEBPACK FOOTER
// ./node_modules/handsontable/es/plugins/bindRowsWithHeaders/bindStrategies/index.js
// module id = 915
// module chunks = 0